import { TaskType } from "../models/TaskType";
import { User } from "../models/User";
import { Priority } from "../models/Priority";
import { Status } from "../models/Status";
import { TaskCustomField } from "../models/TaskCustomField";
import { LogitudeLookupModel } from "../models/LogitudeLookupModel";

export class Task {
    Id: number | null;
    Tenant: number;
    Entity:string|null;
    Title: string | null;
    Description: string;
    Note: string;
    StartDate: Date | null;
    EndDate: Date | null;
    AssigneeId: number;
    OwnerId: number;
    PriorityCode: string;
    StatusCode: string;
    Reminder: boolean;
    Assignee: User;
    Owner: User;
    Partner: LogitudeLookupModel;
    Priority: Priority;
    Status: Status;
    EntityNumber: string | null;
    ParentEntityNumber: string | null;
    ActiveEntityNumber: string | null;
    UserEntryFields: string | null;
    TaskTypeId: number | null;
    TaskType: TaskType;
    CreatedDate: Date;
    CreatedByUserId: number | null;
    UpdatedDate: Date;
    UpdatedByUserId: number | null;
    TaskCustomField: TaskCustomField;
    TaskCustomFieldEntity: TaskCustomField;
    PartnerId: number | null;
    DoneDate: Date | null;
    DoneByUserId: number | null;
    DoneByUser : User | null;
    EnableAutoDone : boolean;
    NextFollowUp: Date | null;
}